import { HighlightsDisplayItem, HighlightsItem, MAX_HIGHLIGHTS_ITEMS } from 'component/page/detail/Highlights/ActivitiesHighlights.types';
import { Highlight } from 'gql/autogen/Highlight';

export const getHighlightsItems = (highlights: Highlight[]): HighlightsItem[] => {
    const highlightsItems: HighlightsItem[] = [];

    highlights.forEach(({ code }) => {
        if (code && code in HighlightsDisplayItem) {
            highlightsItems.push({ code, ...HighlightsDisplayItem[code] });
        }
    });

    if (highlightsItems.length > MAX_HIGHLIGHTS_ITEMS) {
        return highlightsItems.slice(0, MAX_HIGHLIGHTS_ITEMS);
    }

    return highlightsItems;
};
